import logo from "../../Assets/images/protika.png";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { prefixUrl } from "../../Utils/utilsData";

const LoginForm = (props) => {
  const navigateTo = useNavigate();
  const [phone, setPhone] = useState("");
  useEffect(() => {
    const token = localStorage.getItem("tokens");
    if (token) {
      navigateTo("/user");
    } else {
      navigateTo("/login");
    }
  }, []);
  const signupHandler = () => {
    props.setContent("register");
  };
  const loginHandler = () => {
    axios
      .post(`${prefixUrl()}/login/sendCode.php`, {
        phoneNumber: phone,
      })
      .then((response) => {
        if (response.data.status) {
          localStorage.setItem("mobile", phone);
          props.setContent("verify");
          props.setType("login");
        } else {
          toast.error(response.data.output.error);
        }
      });
  };

  
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      loginHandler();
    }
  };
  return (
    <div className="login-form">
      <div className="login-logo">
        <img src={logo} alt="" />
      </div>
      <div className="panel-input">
        <label for=""> شماره تلفن</label>
        <input
          type="number"
          name="loginphone"
          placeholder="شماره موبایل  خود را وارد کنید"
          id="mobileOrEmail"
          onChange={(e) => setPhone(e.target.value)}
          onKeyUp={handleKeyPress}
        />
        <div className="submit-before">
          ثبت نام نکرده ام/<button onClick={signupHandler}>ثبت نام</button>
        </div>
      </div>
      <button type="submit" className="continue-btn" onClick={loginHandler}>
        ورود
      </button>
    </div>
  );
};

export default LoginForm;
